import { Box, Flex } from 'dash-ui';
import styled from 'styled-components';

export const StyledPortfolioWrapper = styled(Box)`
  position: relative;
  border-radius: ${({ theme }) => theme.space * 2}px;
  box-shadow: ${({ theme }) => theme.shadows.shadow2};
  &:hover {
    & > div:first-child {
      display: flex;
    }
  }
`;

export const ImageWrapper = styled(Flex)`
  background: ${({ theme }) => theme.colors.b20};
  border-radius: ${({ theme }) => {
    const radius = theme.space * 2;

    return `${radius}px ${radius}px 0 0`;
  }};
`;
